import { ErrorMessage, Field, FieldArray, Form, Formik } from 'formik';
import Header from '../Header/Header';
import React, { useState, useRef, useEffect, useCallback } from 'react'
import { Name, Role, DOB, LICENSE_NUMBER, SIGNATURE, DAY, FROM_TIME, TO_TIME, phoneNumberRegex, CONTACT_NUMBER, EMAIL, AVAILABILITY, MODALITY, STUDY_REGIONS } from "./utilities/schema"
import { Icon, Select, SuccessModal, Loader, ConfirmationPopup, ICONS, SignaturePad } from '@ohif/ui';
import { apiRequest } from '@custom/Utils/config/apiRequest';
import { _commonUrls, _teleradiologyuserUrls } from '@custom/Utils/constants/apiUrls';
import { useDropzone } from 'react-dropzone';
import { useDispatch, useSelector } from 'react-redux';
import changePasswordApi from '../rtk-apis/user/changePassword';
import { AppDispatch, RootState } from '../store/store';
import { useNavigate, useLocation } from 'react-router-dom';
import { resetUpdateProfileStatus } from '@custom/store/slices/user/updateProfile';
import { resetChangePasswordStatus } from '@custom/store/slices/user/changePassword';
import * as Yup from 'yup';
import './index.css';
import { customStyle, formatDate, getCurrencyContact } from '@custom/Utils/utils';
import updateProfileImage from '@custom/rtk-apis/report/updateProfileImage';
import { useTheme } from "../../ui/src/contextProviders"
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { TextField } from '@mui/material';
import dayjs from 'dayjs';
import getBillingGeneralSettings from '@custom/rtk-apis/billing/getGeneralSettings';

const TeleUserProfile = () => {
    const [image, setImage] = useState('');
    const [countryCode, setCountryCode] = useState(['+91']); // Default country code
    const [roleList, setRoleList] = useState([])
    const [department, setDepartment] = useState([])
    const [preview, setPreview] = useState(''); // State to store image preview
    const [errorMessage, setErrorMessage] = useState(''); // State to store error message
    const [successModal, setSuccessModal] = useState(false); // State to manage success modal visibility
    const [title, setTitle] = useState('');
    const [confirmationModal, setConfirmationModal] = useState(false);
    const [confirmationText, setConfirmationText] = useState("");
    const imageResponse = useSelector((state: RootState) => state.updateProfileImageResponse);
    const billingGeneralSettingsData = useSelector((state: RootState) => state.getBillingGeneralSettingsSliceResponse);
    const [profileImage, setProfileImage] = useState<string>('');
    const [signatureImage, setSignatureImage] = useState<string>('');
    const [isOpenSignaturePad, setOpenSignaturePad] = useState(false);
    const [folderName, setFolderName] = useState<string>('');
    const navigate = useNavigate();
    const location = useLocation();
    const { userDetail } = location?.state || {};
    const [modalities, setModalities] = useState([]);
    const [regions, setRegions] = useState([]);
    const [load, setLoad] = useState(false);
    const [modal, setModal] = useState(false);
    const [days, setDays] = useState([]);
    const [genderOptions, setGenderOption] = useState([]);
    const [selectedCountryCode, setSelectedCountryCode] = useState<string>('+91');

    const defaultCountryCode = billingGeneralSettingsData?.status && billingGeneralSettingsData?.result?.currency ? getCurrencyContact(billingGeneralSettingsData.result.currency) : '+91';

    const [formInitialValue, setFormInitialForm] = useState({
        name: userDetail?.name || '',
        profilePic: userDetail?.profilePic || '',
        contactNumberCountryCode: defaultCountryCode,
        whatsappCountryCode: defaultCountryCode,
        empId: userDetail?.empId || '',
        role: userDetail?.role || '',
        hprId: userDetail?.hprId || '',
        gender: userDetail?.gender || '',
        email: userDetail?.email || '',
        contactNumber: userDetail?.contactNumber || '',
        dob: userDetail?.dob || '',
        department: userDetail?.department || '',
        radiologistType: userDetail?.radiologistType || '',
        modality: userDetail?.modality || [],
        studyRegion: userDetail?.studyRegion || [],
        specialization: userDetail?.specialization || [],
        yearsOfExperience: userDetail?.yearsOfExperience || '',
        whatsappNumber: userDetail?.whatsappNumber || '',
        licenseNumber: userDetail?.licenseNumber || '',
        availabilityDay: userDetail?.availabilityDay || '',
        fromTimeAvailability: userDetail?.fromTimeAvailability || '',
        toTimeAvailability: userDetail?.toTimeAvailability || '',
        signature: userDetail?.signature || '',
        // sameAsContact: false,
        sameAsContact: Boolean(
            userDetail?.contactNumber &&
            userDetail?.whatsappNumber &&
            userDetail?.contactNumber === userDetail?.whatsappNumber &&
            userDetail?.contactNumberCountryCode === userDetail?.whatsappCountryCode
        )
    });

    const getValidationSchema = (role) => {
        return (
            Yup.object().shape({
                name: Yup.string().required(Name.validation.required),
                contactNumberCountryCode: Yup.string(),
                whatsappCountryCode: Yup.string(),
                empId: Yup.string(),
                role: Yup.string().required(Role.validation.required),
                hprid: Yup.string(),
                gender: Yup.string(),
                email: Yup.string().email(EMAIL.validation.valid).required(EMAIL.validation.required).test('no-uppercase', EMAIL.validation.invalidCaps, value => {
                    return !value || value === value.toLowerCase();
                }),
                contactNumber: Yup.string().matches(phoneNumberRegex, CONTACT_NUMBER.validation.valid).required(CONTACT_NUMBER.validation.valid),
                dob: Yup.date().required(DOB.validation.required),
                department: Yup.string(),
                modality: Yup.array().required(MODALITY.validation.required),
                specialization: Yup.array(),
                yearsOfExperience: Yup.string(),
                availabilityDay: Yup.array().required(AVAILABILITY.validation.required),
                fromTimeAvailability: Yup.string().required(FROM_TIME.validation.required),
                toTimeAvailability: Yup.string().required(TO_TIME.validation.required).test(
                    'is-greater',
                    'To time must be later than from time',
                    function (value) {
                        const { fromTimeAvailability } = this.parent;
                        if (!fromTimeAvailability || !value) return true;

                        const [fromHours, fromMinutes] = fromTimeAvailability.split(':');
                        const [toHours, toMinutes] = value.split(':');

                        const fromTotalMinutes = parseInt(fromHours, 10) * 60 + parseInt(fromMinutes, 10);
                        const toTotalMinutes = parseInt(toHours, 10) * 60 + parseInt(toMinutes, 10);

                        return toTotalMinutes > fromTotalMinutes;
                    }
                ),
                whatsappNumber: Yup.string().matches(phoneNumberRegex, CONTACT_NUMBER.validation.valid),
                licenseNumber: Yup.string().required(LICENSE_NUMBER.validation.required),
                signature: Yup.string().required(SIGNATURE.validation.required),
            })
        )
    };

    const onDrop = useCallback((acceptedFiles, setFieldValue) => {
        const file = acceptedFiles[0];
        if (file) {
        const reader = new FileReader();
        reader.onloadend = () => {
            setFieldValue('signature', reader.result);
            uploadSignatureFile(file, setFieldValue );
        };
        reader.readAsDataURL(file);
        }
    }, []);

    const uploadSignatureFile = (file, setFieldValue) => {
        if (file) {
        setFolderName("signature")
        const formData = new FormData();
        formData.append('file', file);
        formData.append('folderName', "signature");

        dispatch(updateProfileImage(formData))
            .unwrap()
            .then((result) => {
            setFieldValue('signature', result);
            })
            .catch((error) => {
            console.error('Error uploading file:', error);
            });
        }
    };

    const base64ToBlob = (base64, type = 'image/png') => {
        const byteCharacters = atob(base64.split(',')[1]); // Decode base64 string
        const byteNumbers = new Array(byteCharacters.length);

        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        return new Blob([byteArray], { type });
    };

    const saveSignature = (signatureData: string, setFieldValue: (field: string, value: any) => void) => {
        setOpenSignaturePad(false);
        const blob = base64ToBlob(signatureData);
        const file = new File([blob], `signature_${Date.now()}.png`, { type: 'image/png' });
        setFieldValue('signature', signatureData);
        uploadSignatureFile(file, setFieldValue);
    };

    const openSignaturePad = () => {
        setOpenSignaturePad(true)
    }

    // handle passwords- currentPassword, newPassword, confirmPassword
    const [password, setPassword] = useState({
        currentPassword: '',
        newPassword: '',
        confirmPassword: '',
    })

    const dispatch = useDispatch<AppDispatch>();
    const {
        status: passwordStatus,
        msg: passwordMsg,
        result: passwordData,
        loading: passwordDataLoading,
        error: passwordError
    } = useSelector((state: RootState) => state?.changePasswordResponse);
    const {
        status: updateProfileStatus,
        msg: updateProfileMsg,
        result: updateProfileData,
        loading: updateProfileDataLoading
    } = useSelector((state: RootState) => state?.updateProfileResponse);

    const handlePasswordChange = async (key, values) => {
        setPassword({ ...password, [key]: values });
    }
    useEffect(() => {
        if (imageResponse?.status === "SUCCESS") {
            if (folderName === 'profile') {
            setProfileImage(imageResponse?.result)
            }
            else {
            setSignatureImage(imageResponse?.result)
            }

        }
    }, [imageResponse])
    useEffect(() => {
        if (updateProfileStatus === 'SUCCESS') {
            setSuccessModal(true);
            setTitle("Profile Updated Successfully.");
            setTimeout(() => {
                navigate(`/user/details/${userDetail?._id}`);
                dispatch(resetUpdateProfileStatus());
            }, 500);
        }
    }, [updateProfileStatus]);

    useEffect(() => {
        if (passwordStatus === 'SUCCESS') {
            setSuccessModal(true);
            setTitle(passwordMsg);
            setTimeout(() => {
                dispatch(resetChangePasswordStatus());
            }, 500);
        }
    }, [passwordStatus]);

    const handlePasswordSubmit = async () => {
        setConfirmationModal(false)
        const { currentPassword, newPassword, confirmPassword } = password;
        if (!currentPassword) {
            setErrorMessage('Current password is required.');
            return;
        }
        if (!newPassword) {
            setErrorMessage('New password is required.');
            return;
        }
        if (newPassword !== confirmPassword) {
            setErrorMessage('New password and confirm password do not match.');
            return;
        }
        const hospitalId = sessionStorage.getItem('hospitalId') || localStorage.getItem('hospitalId');
        const userId = sessionStorage.getItem('userId') || localStorage.getItem('userId');

        const payload = {
            hospitalId: hospitalId,
            userId: userId,
            currentPassword: currentPassword,
            newPassword: newPassword,
            confirmPassword: confirmPassword
        }

        const response = await dispatch(changePasswordApi(payload));

        // Handle API response
        if (response?.meta?.requestStatus === 'fulfilled') {
            if (response?.payload?.status === "SUCCESS") {
                setPassword({ ...password, currentPassword: '', newPassword: '', confirmPassword: '' });
                setErrorMessage('');
            } else if (response?.payload?.status === "ERROR") {
                setErrorMessage(response?.payload?.msg);
            }
        } else if (response?.error?.message) {
            setErrorMessage(response.error.message);
        }
    }

    const fileInputRef = useRef(null);

    const handleImageChange = async (event: React.ChangeEvent<HTMLInputElement>, folderPath) => {
        const file = event.target.files?.[0];
        const folderName = folderPath;
        setFolderName(folderName)

        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                const formData = new FormData();
                formData.append('file', file);
                formData.append('folderName', folderName);

                dispatch(updateProfileImage(formData))
                    .unwrap()
                    .then((result) => {
                        setProfileImage(result.result);
                    })
                    .catch((error) => {
                        console.error('Error uploading file:', error);
                    });

            };
            reader.readAsDataURL(file);
        }
    };

    const fetchCommonData = async () => {
        try {
            const commonData: any = await apiRequest({ method: 'POST', endUrl: _commonUrls.list, body: {}, headerType: 'json' })
            if (commonData?.status) {
                setRoleList(commonData?.result?.roleList);
                setCountryCode(commonData?.result?.countryCode);
                setDepartment(commonData?.result?.department);

                let allLabels = commonData?.result?.modality
                    ?.map(modality => modality.label)
                    .join(", ");
                let modalityData = [{ value: "Multi Speciality", label: "Multi Speciality", meta: allLabels }, ...commonData?.result?.modality];
                setModalities(modalityData);

                let allRegions = commonData?.result?.studyRegions
                    ?.map(modality => modality.label)
                    .join(", ");
                let studyRegionData = [{ value: "All", label: "All", meta: allRegions }, ...commonData?.result?.studyRegions];
                setRegions(studyRegionData);

                const formattedDays = commonData?.result?.day.map((day: string) => ({
                    value: day,
                    label: day,
                }));
                setDays(formattedDays);

                setGenderOption(commonData?.result?.gender);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    const handleSaveForm = async (values) => {
        const userId = sessionStorage.getItem('userId') || localStorage.getItem('userId')
        let obj = {
            _id: userId,
            name: values?.name,
            radiologistType: values?.radiologistType,
            contactNumberCountryCode: values?.contactNumberCountryCode,
            whatsappCountryCode: values?.whatsappCountryCode,
            role: values?.role,
            hprId: values?.hprId,
            gender: values.gender,
            email: values?.email,
            modality: values?.modality,
            studyRegion: values?.studyRegion,
            contactNumber: values?.contactNumber,
            dob: values?.dob,
            department: values?.department,
            yearsOfExperience: values?.yearsOfExperience,
            whatsappNumber: values?.whatsappNumber,
            licenseNumber: values?.licenseNumber,
            availabilityDay: values?.availabilityDay,
            fromTimeAvailability: values?.fromTimeAvailability,
            toTimeAvailability: values?.toTimeAvailability,
            hospitalId: sessionStorage.getItem("hospitalId") || localStorage.getItem('hospitalId'),//teraradiologyId,
            signature: values?.signature,
            sameAsContact: values?.sameAsContact,
            profilePic: profileImage,
        }

        setLoad(true)
        const response = await apiRequest({ method: 'POST', endUrl: _teleradiologyuserUrls.add, body: obj, headerType: 'json' })
        if (response?.status) {
            setLoad(false)
            setModal(true)
            setTitle(response?.msg)
            setTimeout(() => {
                setTitle("")
                navigate("/user/details")
            }, 200);
        }
        else {
            setLoad(false)
        }
    }

    useEffect(() => {
        fetchCommonData()
        dispatch(getBillingGeneralSettings());
        if (userDetail && Object.keys(userDetail).length > 0) {
            setProfileImage(userDetail?.profilePic);
            setPreview(userDetail?.signature);
        }
    }, [dispatch])

    useEffect(() => {
        if (billingGeneralSettingsData?.status === 'success' && billingGeneralSettingsData?.result?.currency) {
            const newCountryCode = getCurrencyContact(billingGeneralSettingsData.result.currency);
            setSelectedCountryCode(newCountryCode);
        }
    }, [billingGeneralSettingsData]);

    const isDarkMode = useTheme();

    return (
        <>
            <div className='page page__full' style={
                isDarkMode?.isDarkMode ? { background: '#090c29' } : customStyle.mainBackground
            }>
                <Header isBack={true} title={"Edit Profile"}></Header>
                <div className='page__body'>
                    <div className='details'>

                        <div className='form form--innersec'>
                            <Formik
                                initialValues={formInitialValue}
                                enableReinitialize={true}
                                validationSchema={Yup.lazy((values) => getValidationSchema(values.role))}
                                onSubmit={handleSaveForm}
                            >
                                {({
                                    errors,
                                    values,
                                    handleChange,
                                    handleBlur,
                                    touched,
                                    setFieldValue,
                                    setFieldTouched,
                                }) => {
                                    useEffect(() => {
                                        setFieldValue('contactNumberCountryCode', selectedCountryCode);
                                        setFieldValue('whatsappCountryCode', selectedCountryCode);
                                    }, [selectedCountryCode]);
                                    return (
                                    <Form>
                                        <section className='form__section'>
                                            <h1 className='form__section__title'> Profile Details</h1>
                                            <div className="formRow formRow__2">
                                                <div className="formCol">
                                                    <div className="form__Field">
                                                        <label className="form__uploadProfile" htmlFor="uploadProfile">
                                                            {profileImage && <img className="form__uploadProfile__picture" src={profileImage} alt="" />}
                                                            <img className="form__uploadProfile__picture" src={ICONS.defaultUserIcon} alt="" />
                                                            <span className="form__uploadProfile__overlay">
                                                                <svg width="17" height="15" viewBox="0 0 17 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <path d="M15.4782 12.1589C15.4782 12.5125 15.3377 12.8516 15.0877 13.1017C14.8376 13.3517 14.4985 13.4922 14.1449 13.4922H2.14486C1.79124 13.4922 1.4521 13.3517 1.20205 13.1017C0.951999 12.8516 0.811523 12.5125 0.811523 12.1589V4.82552C0.811523 4.4719 0.951999 4.13276 1.20205 3.88271C1.4521 3.63266 1.79124 3.49219 2.14486 3.49219H4.81152L6.14486 1.49219H10.1449L11.4782 3.49219H14.1449C14.4985 3.49219 14.8376 3.63266 15.0877 3.88271C15.3377 4.13276 15.4782 4.4719 15.4782 4.82552V12.1589Z" stroke="white" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"></path>
                                                                    <path d="M8.14486 10.8255C9.61762 10.8255 10.8115 9.63161 10.8115 8.15885C10.8115 6.68609 9.61762 5.49219 8.14486 5.49219C6.6721 5.49219 5.47819 6.68609 5.47819 8.15885C5.47819 9.63161 6.6721 10.8255 8.14486 10.8255Z" stroke="white" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"></path>
                                                                </svg>
                                                            </span>
                                                        </label>
                                                        <input type="file" id="uploadProfile" className="form__uploadfiled" ref={fileInputRef} accept=".jpg, .jpeg, .png"
                                                            onChange={(e) => handleImageChange(e, 'profile')} />
                                                    </div>
                                                </div>
                                            </div>
                                        </section>

                                        <section className='form__section'>
                                            <h1 className='form__section__title'>Teleradiologist User Details</h1>
                                            <div className='formRow formRow__2'>
                                                <div className='formCol'>
                                                    <div className="form__Field">
                                                        <label className="form__label" htmlFor='radiologistType'>
                                                            Radiologist Type
                                                            <span className="required-asterisk">*</span>
                                                        </label>
                                                        <select
                                                            className="form__select form__select--sm"
                                                            style={customStyle.select}
                                                            id="radiologistType"
                                                            name="radiologistType"
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            value={values?.radiologistType}
                                                            autoComplete="off"
                                                            disabled={true}
                                                        >
                                                            <option value="" disabled>Select</option>
                                                            <option value="Internal">Internal</option>
                                                            <option value="External">External</option>
                                                        </select>
                                                    </div>
                                                    <ErrorMessage name="radiologistType" component="div" className="error text-error" />
                                                </div>
                                                <div className='formCol'>
                                                    <div className="form__Field">
                                                        <label className="form__label" htmlFor='role' >
                                                            User Role
                                                            <span className="required-asterisk">*</span>
                                                        </label>
                                                        <select
                                                            className="form__select form__select--sm"
                                                            style={customStyle.select}
                                                            id="role"
                                                            name="role"
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            value={values?.role}
                                                            autoComplete="off"
                                                            disabled={true}
                                                        >
                                                            <option value="" disabled>Select</option>
                                                            <option value="Resident">Resident</option>
                                                            <option value="Radiologist">Radiologist</option>
                                                        </select>
                                                    </div>
                                                    <ErrorMessage name="role" component="div" className="error text-error" />
                                                </div>
                                            </div>
                                            <div className="formRow formRow__2">
                                                <div className='formCol'>
                                                    <div className="form__Field">
                                                        <label className="form__label" htmlFor='name'>
                                                            Name
                                                            <span className="required-asterisk">*</span>
                                                        </label>
                                                        <input className="form__input form__input--sm"
                                                            type="text"
                                                            id="name"
                                                            name="name"
                                                            placeholder="Name"
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            value={values?.name}
                                                            autoComplete='off'
                                                        />
                                                    </div>
                                                    <ErrorMessage name="name" component="div" className="error text-error" />
                                                </div>
                                                <div className='formCol'>
                                                    <div className="form__Field">
                                                        <label className="form__label" htmlFor='gender'>Gender</label>
                                                        <div className="form__radio mt-5">
                                                            {genderOptions?.map((option) => (
                                                                <label key={option?.value} className="flex items-center mr-8 custom-radio-container">
                                                                    <input
                                                                        type="radio"
                                                                        name="gender"
                                                                        value={option?.value}
                                                                        checked={option?.value === values?.gender}
                                                                        onChange={handleChange}
                                                                        className="form__radio__input"
                                                                    />
                                                                    <span className="form__radio__label">{option?.label}</span>
                                                                </label>
                                                            ))}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='formRow formRow__2'>
                                                <div className='formCol'>
                                                    <div className="form__Field">
                                                        <label className="form__label" htmlFor='hprId'>
                                                            HPR ID
                                                        </label>
                                                        <input
                                                            className="form__input form__input--sm"
                                                            type="text"
                                                            id="hprId"
                                                            name="hprId"
                                                            placeholder="HPR ID"
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            value={values?.hprId}
                                                            autoComplete='off'
                                                        />
                                                    </div>
                                                </div>
                                                <div className='formCol'>
                                                    <div className="form__Field">
                                                        <label className="form__label">
                                                            Email ID<span className="required-asterisk">*</span>
                                                        </label>
                                                        <input
                                                            className="form__input form__input--sm"
                                                            type="text"
                                                            id="email"
                                                            name="email"
                                                            placeholder="Email ID"
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            value={values?.email}
                                                            disabled={true}
                                                            autoComplete='off'
                                                        />
                                                        <ErrorMessage name="email" component="div" className="error text-error" />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='formRow formRow__2'>
                                                <div className='formCol'>
                                                    <div className="form__Field">
                                                        <label className="form__label" htmlFor='contactName'>
                                                            Contact Number<span className="required-asterisk">*</span>
                                                        </label>
                                                        <div className='form__groupField form__groupField--phonenumber'>
                                                            <select className="form__select form__select--sm" id="contactNumberCountryCode"
                                                                style={customStyle.select}
                                                                name="contactNumberCountryCode"
                                                                value={values?.contactNumberCountryCode}
                                                                onChange={(e) => {
                                                                    handleChange(e);
                                                                    if (values.sameAsContact || (values.contactNumber === values.whatsappNumber && values.whatsappNumber)) {
                                                                        setFieldValue('whatsappCountryCode', e.target.value);
                                                                        setFieldValue('whatsappNumber', values.contactNumber);
                                                                        setFieldValue('sameAsContact', true);
                                                                    }
                                                                }}>
                                                                {countryCode.map((option) => (
                                                                    <option 
                                                                    key={option} 
                                                                    value={option} 
                                                                    disabled={billingGeneralSettingsData?.status === 'success' && option !== selectedCountryCode}
                                                                    >
                                                                    {option}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                            <input type="text"
                                                                className="form__input form__input--sm"
                                                                id="contactNumber"
                                                                name="contactNumber"
                                                                placeholder="Contact Number"
                                                                maxLength={10}
                                                                onChange={(e) => {
                                                                    handleChange(e);
                                                                    if (values.sameAsContact || (e.target.value === values.whatsappNumber && values.whatsappNumber)) {
                                                                        setFieldValue('whatsappNumber', e.target.value);
                                                                        setFieldValue('sameAsContact', true);
                                                                    } else {
                                                                        setFieldValue('sameAsContact', false);
                                                                    }
                                                                }}
                                                                onBlur={handleBlur}
                                                                value={values.contactNumber}
                                                                autoComplete='off'>
                                                            </input>
                                                        </div>

                                                        <ErrorMessage name="contactNumber" component="div" className="error text-error" />
                                                    </div>
                                                </div>
                                                <div className='formCol'>
                                                    <div className="form__Field">
                                                        <label className="form__label">
                                                            Date of Birth<span className="required-asterisk">*</span>
                                                        </label>
                                                        <div className="form__date-container">
                                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                                <Field name="dob" style={{ width: '100%' }}>
                                                                    {({ field }) => (
                                                                        <DatePicker
                                                                            sx={{
                                                                                width: '100%',
                                                                                '& .MuiInputBase-root': {
                                                                                    backgroundColor: '#F6FFFF',
                                                                                    borderRadius: '2rem'
                                                                                },
                                                                                '& .MuiInputBase-input': {
                                                                                    padding: '10px',
                                                                                },
                                                                            }}
                                                                            {...field}
                                                                            value={field.value || null}
                                                                            format="DD/MM/YYYY"
                                                                            maxDate={dayjs()}
                                                                            onChange={(newValue) => {
                                                                                setFieldValue(field.name, newValue);
                                                                            }}
                                                                            renderInput={(params) => (
                                                                                <TextField
                                                                                    {...params}
                                                                                    error={touched.date && Boolean(errors.date)}
                                                                                    helperText={touched.date && errors.date}
                                                                                />
                                                                            )}
                                                                        />
                                                                    )}
                                                                </Field>
                                                            </LocalizationProvider>
                                                        </div>
                                                        <ErrorMessage name="dob" component="div" className="error text-error" />

                                                    </div>
                                                </div>
                                            </div>
                                            <div className='formRow formRow__2'>

                                                <div className='formCol'>
                                                    <div className="form__Field">
                                                        <label className="form__label">
                                                            Department
                                                        </label>
                                                        <select
                                                            id="department"
                                                            name="department"
                                                            className="form__select form__select--sm"
                                                            style={customStyle.select}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            value={values?.department}
                                                            autoComplete='off'
                                                        >
                                                            <option value="" disabled>Department</option>
                                                            {department.map((option) => (
                                                                <option key={option} value={option}>
                                                                    {option}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className='formCol'>
                                                    <div className="form__Field">
                                                        <label className="form__label" htmlFor='modality'>Expertise<span className="required-asterisk">*</span></label>
                                                        <Select
                                                            id='modality'
                                                            placeholder='Select'
                                                            className='custom-bg-white'
                                                            isMulti
                                                            isClearable={false}
                                                            isSearchable
                                                            closeMenuOnSelect={false}
                                                            hideSelectedOptions={false}
                                                            options={modalities}
                                                            value={values?.modality}
                                                            onChange={(selectedOptions) => {
                                                                const newModalities = selectedOptions ? selectedOptions.map(option => option) : [];
                                                                setFieldValue('modality', newModalities);
                                                            }}
                                                        />
                                                    </div>
                                                    <ErrorMessage name="modality" component="div" className="error text-error" />

                                                </div>
                                            </div>
                                            <div className="formRow formRow__2">

                                                <div className='formCol'>
                                                    <div className="form__Field">
                                                        <label className="form__label" htmlFor='studyRegion'>Study Region</label>
                                                        <Select
                                                            id='studyRegion'
                                                            placeholder='Select'
                                                            className='custom-bg-white'
                                                            isMulti
                                                            isClearable={false}
                                                            isSearchable
                                                            closeMenuOnSelect={false}
                                                            hideSelectedOptions={false}
                                                            options={regions}
                                                            value={values?.studyRegion}
                                                            onChange={(selectedOptions) => {
                                                                const newRegions = selectedOptions ? selectedOptions.map(option => option) : [];
                                                                setFieldValue('studyRegion', newRegions);
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                                <div className='formCol'>
                                                    <div className="form__Field">
                                                        <label className="form__label" htmlFor='numberOfHealthcareProfessionals'>Years of Experience</label>
                                                        <input
                                                            className="form__input form__input--sm"
                                                            type="number"
                                                            id="yearsOfExperience"
                                                            name="yearsOfExperience"
                                                            placeholder="--"
                                                            min='0'
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            value={values.yearsOfExperience}
                                                            autoComplete='off'
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='formRow formRow__2'>
                                                <div className='formCol'>
                                                    <div className="form__Field">
                                                        <label className="form__label" htmlFor='whatsappNumber'>Whatsapp Number</label>
                                                        <div className="form__groupField form__groupField--phonenumber">
                                                            <select
                                                                id="whatsappCountryCode"
                                                                style={customStyle.select}
                                                                className="form__select form__select--sm"
                                                                name="whatsappCountryCode"
                                                                value={values.whatsappCountryCode}
                                                                onChange={handleChange}
                                                            >
                                                                {countryCode.map((option) => (
                                                                    <option 
                                                                    key={option} 
                                                                    value={option} 
                                                                    disabled={billingGeneralSettingsData?.status === 'success' && option !== selectedCountryCode}
                                                                    >
                                                                    {option}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                            <input
                                                                type="text"
                                                                className="form__input form__input--sm"
                                                                id="whatsappNumber"
                                                                name="whatsappNumber"
                                                                placeholder="Whatsapp Number"
                                                                maxLength={10}
                                                                onChange={(e) => {
                                                                    handleChange(e);
                                                                    if (e.target.value === values.contactNumber && values.contactNumber) {
                                                                        setFieldValue('sameAsContact', true);
                                                                    } else {
                                                                        setFieldValue('whatsappNumber', '');
                                                                        setFieldValue('sameAsContact', false);
                                                                    }
                                                                }}
                                                                onBlur={handleBlur}
                                                                value={values.whatsappNumber}
                                                                autoComplete='off'
                                                            />
                                                        </div>
                                                        <div className="form__checkboxSubField">
                                                            <div className="form__checkbox">
                                                                <div className="form__checkbox__option m_0">
                                                                    <input
                                                                        className="form__checkbox__input"
                                                                        id="sameAsContact"
                                                                        checked={values.sameAsContact}
                                                                        type="checkbox"
                                                                        name="sameAsContact"
                                                                        onChange={(e) => {
                                                                            setFieldValue('sameAsContact', e.target.checked);
                                                                            if (e.target.checked) {
                                                                                if (values.contactNumber) {
                                                                                    setFieldValue('whatsappNumber', values.contactNumber);
                                                                                    setFieldValue('whatsappCountryCode', values.contactNumberCountryCode);
                                                                                }
                                                                            } else {
                                                                                setFieldValue('whatsappNumber', '');
                                                                                setFieldValue('whatsappCountryCode', '');
                                                                            }
                                                                        }}
                                                                    />

                                                                    <label htmlFor="sameAsContact" className="form__checkbox__label">
                                                                        Same as Contact Number
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <ErrorMessage name="whatsappNumber" component="div" className="error text-error" />
                                                    </div>
                                                </div>
                                                <div className='formCol'>
                                                    <div className="form__Field">
                                                        <label className="form__label" htmlFor='numberOfHealthcareProfessionals'>
                                                            State Medical Council Registration License Number
                                                            {values?.role !== 'Admin' && values?.role !== 'Front Desk' && <span className="required-asterisk">*</span>}
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className="form__input form__input--sm"
                                                            id="licenseNumber"
                                                            name="licenseNumber"
                                                            placeholder="License Number"
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            value={values.licenseNumber}
                                                            autoComplete='off'
                                                        />
                                                        <ErrorMessage name="licenseNumber" component="div" className="error text-error" />
                                                    </div>
                                                    <div className='form__Field'></div>
                                                </div>
                                            </div>

                                            <div className='formRow formRow__2'>
                                                <div className='formCol'>
                                                    <div className="form__Field">
                                                        <label className="form__label" htmlFor='availabilityDay'>
                                                            Availability (Days)
                                                            <span className="required-asterisk">*</span>
                                                        </label>
                                                        <Select
                                                            id='availabilityDay'
                                                            placeholder='Select'
                                                            className='custom-bg-white'
                                                            isMulti
                                                            isClearable={false}
                                                            isSearchable
                                                            closeMenuOnSelect={false}
                                                            hideSelectedOptions={false}
                                                            options={days}
                                                            value={values.availabilityDay || []}
                                                            onChange={(selectedOptions) => {
                                                                setFieldValue('availabilityDay', selectedOptions || []);
                                                            }}
                                                        />
                                                    </div>
                                                    <ErrorMessage name="availabilityDay" component="div" className="error text-error" />
                                                </div>
                                                <div className='formCol'>
                                                    <div className="form__Field">
                                                        <label className="form__label" htmlFor='fromTimeAvailability'>
                                                            From Timing
                                                            <span className="required-asterisk">*</span>
                                                        </label>
                                                        <input
                                                            className="form__input form__input--sm"
                                                            type="time"
                                                            id="fromTimeAvailability"
                                                            name="fromTimeAvailability"
                                                            min='00:00'
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            value={values.fromTimeAvailability}
                                                            defaultValue="00:00"
                                                            autoComplete='off'
                                                        />
                                                    </div>
                                                    <ErrorMessage name="fromTimeAvailability" component="div" className="error text-error" />
                                                </div>
                                            </div>
                                            <div className="formRow formRow__2">

                                                <div className='formCol'>
                                                    <div className="form__Field">
                                                        <label className="form__label" htmlFor='toTimeAvailability'>
                                                            To Timing
                                                            <span className="required-asterisk">*</span>
                                                        </label>
                                                        <input
                                                            className="form__input form__input--sm"
                                                            type="time"
                                                            id="toTimeAvailability"
                                                            name="toTimeAvailability"
                                                            min='00:00'
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            value={values.toTimeAvailability}
                                                            defaultValue="00:00"
                                                            autoComplete='off'
                                                        />
                                                    </div>
                                                    <ErrorMessage name="toTimeAvailability" component="div" className="error text-error" />
                                                </div>
                                            </div>
                                        </section>

                                        <section className='form__section'>
                                            <h1 className='form__section__title'>Change Password</h1>
                                            <div className='formRow formRow__4'>
                                                <div className='formCol'>
                                                    <div className="form__Field">
                                                        <label className="form__Label" htmlFor='currentPassword'>
                                                            Current Password
                                                        </label>
                                                        <input
                                                            type="password"
                                                            id="currentPassword"
                                                            name="currentPassword"
                                                            placeholder="Current Password"
                                                            className="form__input form__input--sm"
                                                            value={password.currentPassword}
                                                            onChange={
                                                                (event) => handlePasswordChange('currentPassword', event.target.value)
                                                            }
                                                            autoComplete='off'
                                                        />
                                                    </div>
                                                </div>
                                                <div className='formCol'>
                                                    <div className="form__Field">
                                                        <label className="form__Label" htmlFor='newPassword'>
                                                            New Password
                                                        </label>
                                                        <input
                                                            type="password"
                                                            id="newPassword"
                                                            name="newPassword"
                                                            placeholder="New Password"
                                                            className="form__input form__input--sm"
                                                            value={password.newPassword}
                                                            onChange={
                                                                (event) => handlePasswordChange('newPassword', event.target.value)
                                                            }
                                                            autoComplete='off'
                                                        />
                                                    </div>
                                                </div>
                                                <div className='formCol'>
                                                    <div className="form__Field">
                                                        <label className='form__Label' htmlFor='confirmPassword'>
                                                            Confirm Password
                                                        </label>
                                                        <input
                                                            type="password"
                                                            id="confirmPassword"
                                                            name="confirmPassword"
                                                            placeholder="Confirm Password"
                                                            className="form__input form__input--sm"
                                                            value={password.confirmPassword}
                                                            onChange={
                                                                (event) => handlePasswordChange('confirmPassword', event.target.value)
                                                            }
                                                            autoComplete='off'
                                                        />
                                                    </div>
                                                </div>
                                                <div className='formCol'>
                                                    <div className="form__Field">
                                                        <label htmlFor="">&nbsp;</label>
                                                        <span
                                                            className='btn btn__primary'
                                                            onClick={() => {
                                                                setTitle("Update Password")
                                                                setConfirmationText("Are you sure you want update your password?")
                                                                setConfirmationModal(true)
                                                            }}
                                                        >
                                                            Update Password
                                                        </span>
                                                    </div>
                                                </div>
                                                {errorMessage && <span className='text-error text-xs' style={{ color: 'red' }}>{errorMessage}</span>}
                                            </div>
                                        </section>
                                        <section className='form__section'>
                                            <div className="formRow">
                                                <div className="formCol">
                                                    <div className="form__Field">
                                                        <label className='form__Label' htmlFor='signature'>
                                                            Upload Signature
                                                            {userDetail?.role !== "Front Desk" && <span className="required-asterisk">*</span>}
                                                        </label>
                                                        <div className='cursor-pointer relative'>
                                                            <SignatureDropzone onDrop={(acceptedFiles) => onDrop(acceptedFiles, setFieldValue)} preview={values?.signature} accept={{ 'image/jpeg': ['.jpeg', '.jpg'], 'image/png': ['.png'] }} />
                                                        </div>
                                                        <div>
                                                            <p className="addSignatureNote" style={{ color: isDarkMode?.isDarkMode ? '#ffffff' : '#a00000' }}> Note: Please use a black pen and white paper to sign </p>
                                                            <p className='addSignatureDiv -mt-2'>Or</p>
                                                        </div>
                                                        <div className='addSignatureDiv'>
                                                            <button className="btn btn__white" type="button" onClick={openSignaturePad}> Add Signature</button>
                                                        </div>
                                                        <ErrorMessage name="signature" component="div" className="text-red-500 font-xs" />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='btn__group'>
                                                <button
                                                    className='btn btn__white'
                                                    onClick={() => {
                                                        navigate(`/user/details/${userDetail?._id}`)
                                                    }}
                                                >
                                                    Cancel
                                                </button>
                                                <button
                                                    className='btn btn__primary'
                                                    type="submit"
                                                >
                                                    Update
                                                </button>
                                            </div>
                                        </section>
                                        <SignaturePad
                                            title={title}
                                            message={confirmationText}
                                            onConfirm={(signatureData) => saveSignature(signatureData, setFieldValue)}
                                            onCancel={() => {
                                                setOpenSignaturePad(false);
                                            }}
                                            isOpen={isOpenSignaturePad}
                                        />
                                    </Form>
                                )}}
                            </Formik>

                        </div>
                    </div>
                </div>
            </div>
            <ConfirmationPopup
                title={title}
                message={confirmationText}
                onConfirm={handlePasswordSubmit}
                onCancel={() => {
                    setTitle('')
                    setConfirmationText('')
                    setConfirmationModal(false)
                }}
                isOpen={confirmationModal}
            />
            <SuccessModal
                isSuccessModalOpen={successModal}
                title={title}
                handleCloseModal={() => setSuccessModal(false)}
            />
        </>

    )
}

export default TeleUserProfile

export const SignatureDropzone = ({ onDrop, preview }) => {
    const [error, setError] = useState(null);

    const handleDrop = (acceptedFiles) => {
        const maxSize = 3 * 1024 * 1024; // 3 MB
        const validFiles = [];

        setError(null);

        for (const file of acceptedFiles) {
            if (file.size <= maxSize) {
                validFiles.push(file);
            } else {
                // Remove previous image and show error
                onDrop([]); // Clear previous images
                setError(`File ${file.name} is too large. Maximum image size is 3 MB.`);
                break; // Exit loop after showing error
            }
        }

        if (validFiles.length > 0) {
            onDrop(validFiles); // Send valid files to the parent
        }
    };

    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop: handleDrop,
        accept: {
            'image/jpeg': ['.jpg', '.jpeg'],
            'image/png': ['.png'],
        },
    });

    return (
        <div
            {...getRootProps()}
            style={{
                border: '2px dashed #cccccc',
                padding: '20px',
                textAlign: 'center',
                marginBottom: '10px',
                width: '100%',
                height: '150px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: isDragActive ? '#f0f0f0' : 'white',
                position: 'relative',
                overflow: 'hidden',
            }}
        >
            <input {...getInputProps()} />
            <div className='text-center flex flex-col items-center justify-center'>
                {!preview ? (
                    <>
                        <Icon name="Upload_Icon" alt="appointmentPreview" />
                        <p>Drag & Drop files or <span className='main-theme-color underline' style={{ textDecoration: 'underline' }}>Browse</span></p>
                        <p>Supported format: <span className='main-theme-color'>JPEG, PNG</span></p>
                    </>
                ) : (
                    <img
                        src={preview}
                        alt="Signature Preview"
                        style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'contain',
                        }}
                    />
                )}
                {error && <p className="text-red-500">{error}</p>}
            </div>
        </div>
    );
};
